export const createDefaultDialogForm = () => ({
  id: null,
  title: '',
  minNight: 2,
  type: 'stay',
  valueType: 'fixed',
  operator: '-',
  value: 0,
  roomTypeIds: [],
  dateRange: [],
  validFrom: null,
  validUntil: null,
  state: 1,
})

export const DIALOG_VALUE_TYPE_OPTIONS = [{ label: '固定金額', value: 'fixed' }, { label: '百分比', value: '%' }]

export const DIALOG_OPERATOR_OPTIONS = [{ label: '減價', value: '-' }, { label: '加價', value: '+' }]

export const DIALOG_TYPE_OPTIONS = [{ label: '連續住宿', value: 'stay' }, { label: '期間限定', value: 'period' }]

export const DIALOG_LABELS = {
  createTitle: '新增房價調度',
  editTitle: '編輯房價調度',
  title: '優惠標題',
  titlePlaceholder: '請輸入優惠標題',
  minNight: '連住天數',
  type: '類型',
  valueType: '優惠類型',
  value: '金額',
  roomType: '適用房型',
  roomTypePlaceholder: '請選擇房型',
  dateRange: '期間設定',
  startDate: '開始日期',
  endDate: '結束日期',
  cancel: '取消',
  save: '儲存',
}
